import gql from 'graphql-tag';

export const MARKET_STATS_FRAGMENT = gql`
    fragment MARKET_STATS_FRAGMENT on ListingData {
        counts {
            numBedrooms
        }
        marketStats {
            areaName
            areaNameUri
            propertyTypeGroup
            askingPrices {
                toRent {
                    meanValue
                }
            }
            historicalEstimates {
                overMonth
                value
                pctChangeSince
                date
                changeSince
            }
            sales {
                overYear
                mean
                newBuilds
                numSales
            }
            recentSales {
                date
                price
                propertyId
                streetAddress
                uri
            }
        }
    }
`;
